import { IconChevronRight16, ArticleHeading3, ArticleParagraph2 } from '@cian/ui-kit';
import * as React from 'react';

import { IDealStepCardProps } from '../DealStepCardDesktop';

import * as styles from './styles.css';

/**
 * Карточка в секции "Лёгкий путь к сделке за 3 шага".
 */
export const DealStepCardHandheld: React.FC<IDealStepCardProps> = props => {
  return (
    <li className={styles['card']} onClick={props.onLearnMoreClick}>
      <div className={styles['counter']} />
      <div className={styles['chip']}>
        <ArticleParagraph2 color="gray60_100">{props.chip}</ArticleParagraph2>
      </div>
      <ArticleHeading3 as="h3">
        <span className={styles['title']}>{props.title}</span>
      </ArticleHeading3>
      <div className={styles['arrow']}>
        <IconChevronRight16 color="gray60_100" />
      </div>
    </li>
  );
};
